<div>
 <app-notifications data-testid="sandbox-notification"></app-notifications>
</div>